<template>
  <div>
    <b-modal
      size="xl"
      body-class="pt-0 pb-0"
      ok-title="Cerrar"
      ok-only
      id="hover-modal"
    >
      <template #modal-title>Comprobar uniones</template>
      <b-row>
        <div
          :style="{
            width: '100%',
            height: '30em',
            backgroundSize: '150px',
            backgroundImage: 'url(' + form.imageURI + ')',
            backgroundRepeat: 'repeat',
          }"
        ></div>
        <b-col :cols="12"> </b-col>
      </b-row>
    </b-modal>
    <b-modal
      @ok="cropIcon"
      @shown="cropIconModalShown"
      no-title
      ok-title="Guardar"
      cancel-title="Cancelar"
      no-close-on-backdrop
      id="icon-cropper-modal"
    >
      <template #modal-title>Icono de tela</template>
      <div class="d-block text-center">
        <p class="text-left">
          Zoom in/out con rueda del ratón (no hacer zoom en telas estampadas)
        </p>
        <vue-cropper
          :aspectRatio="3 / 2"
          ref="cropper"
          :src="form.imageURI"
          alt="Source Image"
        >
        </vue-cropper>
      </div>
    </b-modal>
    <b-container variant="primary" fluid class="p-5">
      <b-row>
        <b-col :cols="12">
          <h3>Editar tela</h3>
          <!-- Form -->
          <b-form @submit.stop.prevent="onSubmit">
            <b-alert :show="form.error.show" variant="danger">{{
              form.error.text
            }}</b-alert>

            <h4>Características</h4>

            <b-form-row>
              <b-col cols="6">
                <b-form-row>
                  <!-- Reference -->
                  <b-form-group
                    id="input-reference"
                    class="col-6"
                    label="Nombre de tela"
                    label-for="reference"
                  >
                    <b-form-input
                      id="reference"
                      v-model="$v.form.reference.$model"
                      :state="validateState('reference')"
                      aria-describedby="input-reference-feedback"
                    ></b-form-input>
                    <b-form-invalid-feedback id="input-reference-feedback"
                      >Este campo es obligatorio.</b-form-invalid-feedback
                    >
                  </b-form-group>

                  <!-- Code hex -->
                  <b-form-group
                    id="input-image"
                    class="col-6"
                    label="Tela madre"
                    label-for="image"
                    description="Dejar vacío para mantener la imagen actual"
                  >
                    <b-form-file
                      accept="image/*"
                      id="image"
                      v-model="$v.form.image.$model"
                      :state="validateState('image')"
                      @input="changedImage"
                      aria-describedby="input-image-feedback"
                      drop-placeholder="Arrastra un archivo aquí..."
                    ></b-form-file>
                    <b-form-invalid-feedback id="input-image-feedback"
                      >Debes seleccionar una imagen válida (formato PNG o
                      JPEG).</b-form-invalid-feedback
                    >
                  </b-form-group>
                </b-form-row>
                <b-form-row>
                  <b-form-group
                    id="input-provider"
                    class="col-3"
                    label="Proveedor"
                    label-for="provider"
                  >
                    <b-form-input
                      id="provider"
                      v-model="$v.form.provider.$model"
                      :state="validateState('provider')"
                      aria-describedby="input-provider-feedback"
                    ></b-form-input>
                    <b-form-invalid-feedback id="input-provider-feedback"
                      >Este campo es obligatorio.</b-form-invalid-feedback
                    >
                  </b-form-group>

                  <b-form-group
                    id="input-ref_provider"
                    class="col-3"
                    label="Ref. proveedor"
                    label-for="ref_provider"
                  >
                    <b-form-input
                      id="ref_provider"
                      v-model="$v.form.ref_provider.$model"
                      :state="validateState('ref_provider')"
                      aria-describedby="input-ref_provider-feedback"
                    ></b-form-input>
                    <b-form-invalid-feedback id="input-ref_provider-feedback"
                      >Este campo es obligatorio.</b-form-invalid-feedback
                    >
                  </b-form-group>

                  <!-- Medidas tela madre -->

                  <b-form-group
                    id="input-base_width"
                    class="col-6"
                    label="Medidas tela madre (Alto x Ancho)"
                    label-for="base_width"
                  >
                    <b-form-row>
                      <b-col :cols="6">
                        <b-input-group>
                          <b-form-input
                            id="base_width"
                            :value="$v.form.base_width.$model.replace('.', ',')"
                            @change="setDecimal('base_width', $event)"
                            :state="validateState('base_width')"
                            aria-describedby="input-base_width-feedback"
                          ></b-form-input>
                          <template #append>
                            <b-input-group-text>cm</b-input-group-text>
                          </template>
                        </b-input-group>
                        <b-form-invalid-feedback id="input-base_width-feedback"
                          >Este campo es obligatorio.</b-form-invalid-feedback
                        >
                      </b-col>
                      <b-col :cols="6">
                        <b-input-group>
                          <b-form-input
                            id="base_length"
                            :value="
                              $v.form.base_length.$model.replace('.', ',')
                            "
                            @change="setDecimal('base_length', $event)"
                            :state="validateState('base_length')"
                            aria-describedby="input-base_length-feedback"
                          ></b-form-input>
                          <template #append>
                            <b-input-group-text>cm</b-input-group-text>
                          </template>
                        </b-input-group>
                        <b-form-invalid-feedback id="input-base_length-feedback"
                          >Este campo es obligatorio.</b-form-invalid-feedback
                        >
                      </b-col>
                    </b-form-row>
                  </b-form-group>
                </b-form-row></b-col
              >
              <b-col class="pb-2 pl-2 pr-2" cols="6">
                <label
                  >Vista previa tela madre e icono
                  <a href="#" @click="$bvModal.show('icon-cropper-modal')"
                    >({{ form.iconURI ? 'cambiar' : 'establecer' }})</a
                  >
                  &nbsp;
                  <a
                    v-if="form.imageURI"
                    href="#"
                    @click="$bvModal.show('hover-modal')"
                    >(comprobar uniones)</a
                  ></label
                >
                <b-form-row>
                  <b-form-group id="input-preview" class="col-auto">
                    <div>
                      <img
                        @mouseover="mouseOver()"
                        @mouseout="mouseOut()"
                        style="max-height: 10rem"
                        :src="form.imageURI"
                      />
                    </div>
                  </b-form-group>

                  <b-form-group id="input-preview" class="col-auto">
                    <div>
                      <img style="max-height: 10rem" :src="form.iconURI" />
                    </div>
                  </b-form-group>
                </b-form-row>
              </b-col>
            </b-form-row>

            <b-form-row>
              <b-form-group
                id="input-width"
                class="col-3"
                label="Ancho"
                label-for="width"
                description="IA_ANCHO_TELA"
              >
                <b-input-group>
                  <b-form-input
                    id="width"
                    :value="$v.form.width.$model.replace('.', ',')"
                    @change="setDecimal('width', $event)"
                    :state="validateState('width')"
                    aria-describedby="input-width-feedback"
                  ></b-form-input>
                  <template #append>
                    <b-input-group-text>cm</b-input-group-text>
                  </template>
                </b-input-group>

                <b-form-invalid-feedback id="input-width-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                id="input-composition"
                class="col-3"
                label="Composición"
                label-for="composition"
              >
                <multiselect
                  track-by="value"
                  :class="$v.form.composition.$error ? 'is-invalid' : ''"
                  :multiple="false"
                  :close-on-select="false"
                  :clear-on-select="true"
                  placeholder=""
                  label="text"
                  v-model="$v.form.composition.$model"
                  :options="form.optionsCompositions"
                >
                </multiselect>
              </b-form-group>

              <b-form-group
                id="input-primary_color_code_hex"
                class="col-1"
                label="Color (hex)"
                label-for="primary_color_code_hex"
              >
                <b-input-group>
                  <b-form-input
                    type="color"
                    id="primary_color_code_hex"
                    v-model="$v.form.primary_color_code_hex.$model"
                    :state="validateState('primary_color_code_hex')"
                    aria-describedby="input-primary_color_code_hex-feedback"
                  ></b-form-input>
                </b-input-group>
                <b-form-invalid-feedback
                  id="input-primary_color_code_hex-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                id="input-extra_type"
                class="col-2"
                description="ej. FLECOS_IND_LAT_BLANCOS"
                label="Tipo extra"
                label-for="extra_type"
              >
                <b-form-input
                  id="extra_type"
                  v-model="$v.form.extra_type.$model"
                  :state="validateState('extra_type')"
                  aria-describedby="input-extra_type-feedback"
                ></b-form-input>
                <b-form-invalid-feedback id="input-extra_type-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
              <b-form-group
                id="input-weight"
                class="col-2"
                label="Peso / Gramaje?"
                label-for="weight"
              >
                <b-input-group>
                  <b-form-input
                    id="weight"
                    :value="$v.form.weight.$model.replace('.', ',')"
                    @change="setDecimal('weight', $event)"
                    :state="validateState('weight')"
                    aria-describedby="input-weight-feedback"
                  ></b-form-input>
                  <template #append>
                    <b-input-group-text>g/m<sup>2</sup></b-input-group-text>
                  </template>
                </b-input-group>
                <b-form-invalid-feedback id="input-weight-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row>

            <b-form-row>
              <b-form-group
                id="input-weight"
                class="col-3"
                label="Transparencia"
                label-for="weight"
              >
                <b-form-checkbox
                  switch
                  v-model="$v.form.transparency.$model"
                  name="input-transparency"
                  >{{
                    $v.form.transparency.$model ? 'Sí' : 'No'
                  }}</b-form-checkbox
                >

                <b-form-invalid-feedback id="input-weight-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
              <b-form-group
                id="input-show_our_fabrics"
                class="col-3"
                label="Mostrar en Nuestras Telas"
                label-for="show_our_fabrics"
              >
                <b-form-checkbox
                  switch
                  v-model="$v.form.show_our_fabrics.$model"
                  name="input-show_our_fabrics"
                  >{{
                    $v.form.show_our_fabrics.$model ? 'Sí' : 'No'
                  }}</b-form-checkbox
                >

                <b-form-invalid-feedback id="input-show_our_fabrics-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                id="input-is_discontinued"
                class="col-3"
                label="Descatalogada"
                description="No aparecerá en la web pero seguirá pudiéndose presupuestar"
                label-for="is_discontinued"
              >
                <b-form-checkbox
                  switch
                  v-model="$v.form.is_discontinued.$model"
                  name="input-is_discontinued"
                  >{{
                    $v.form.is_discontinued.$model ? 'Sí' : 'No'
                  }}</b-form-checkbox
                >

                <b-form-invalid-feedback id="input-is_discontinued-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                id="input-color_families"
                class="col-3"
                label="Familias de color"
                label-for="color_families"
              >
                <multiselect
                  track-by="value"
                  :class="$v.form.color_families.$error ? 'is-invalid' : ''"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="true"
                  placeholder=""
                  label="text"
                  v-model="$v.form.color_families.$model"
                  :options="form.optionsColorFamilies"
                >
                </multiselect>
              </b-form-group>
              <b-form-group
                id="input-design"
                class="col-3"
                label="Diseño de tela"
                label-for="design"
              >
                <multiselect
                  track-by="value"
                  :class="$v.form.design.$error ? 'is-invalid' : ''"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="true"
                  placeholder=""
                  label="text"
                  v-model="$v.form.design.$model"
                  :options="form.optionsDesigns"
                >
                </multiselect>
              </b-form-group>
            </b-form-row>

            <h5>Rapport</h5>

            <b-form-row class="mt-3">
              <b-form-group
                id="input-num_barcada"
                class="col-2"
                label="Núm. barcada actual"
                label-for="num_barcada"
              >
                <b-input-group>
                  <b-form-input
                    id="num_barcada"
                    v-model="$v.form.num_barcada.$model"
                    :state="validateState('num_barcada')"
                    aria-describedby="input-num_barcada-feedback"
                  ></b-form-input>
                </b-input-group>
                <b-form-invalid-feedback id="input-num_barcada-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
              <b-form-group
                id="input-meters_barcada_remaining"
                class="col-2"
                label="Metros barcada actual"
                label-for="meters_barcada_remaining"
              >
                <b-input-group>
                  <b-form-input
                    id="meters_barcada_remaining"
                    :value="
                      $v.form.meters_barcada_remaining.$model.replace('.', ',')
                    "
                    @change="setDecimal('meters_barcada_remaining', $event)"
                    :state="validateState('meters_barcada_remaining')"
                    aria-describedby="input-meters_barcada_remaining-feedback"
                  ></b-form-input>
                </b-input-group>
                <b-form-invalid-feedback
                  id="input-meters_barcada_remaining-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row>

            <b-form-row>
              <b-col :cols="12"><h5>Encogimiento</h5></b-col>

              <b-col :cols="2"></b-col>
              <b-col :cols="2">Ancho</b-col>
              <b-col :cols="2">Largo</b-col>
              <b-col :cols="6"></b-col>

              <b-col :cols="2">por orillo</b-col>
              <b-col :cols="2"
                ><b-form-group
                  id="input-shrinking_selvage_width"
                  class="col-8 pl-0"
                  label-for="shrinking_selvage_width"
                >
                  <b-input-group>
                    <b-form-input
                      id="shrinking_selvage_width"
                      :value="
                        $v.form.shrinking_selvage_width.$model.replace('.', ',')
                      "
                      @change="setDecimal('shrinking_selvage_width', $event)"
                      :state="validateState('shrinking_selvage_width')"
                      aria-describedby="input-shrinking_selvage_width-feedback"
                    ></b-form-input>
                    <template #append>
                      <b-input-group-text>cm</b-input-group-text>
                    </template>
                  </b-input-group>
                  <b-form-invalid-feedback
                    id="input-shrinking_selvage_width-feedback"
                    >Este campo es obligatorio.</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col :cols="2"
                ><b-form-group
                  id="input-shrinking_selvage_long"
                  class="col-8 pl-0"
                  label-for="shrinking_selvage_long"
                >
                  <b-input-group>
                    <b-form-input
                      id="shrinking_selvage_long"
                      :value="
                        $v.form.shrinking_selvage_long.$model.replace('.', ',')
                      "
                      @change="setDecimal('shrinking_selvage_long', $event)"
                      :state="validateState('shrinking_selvage_long')"
                      aria-describedby="input-shrinking_selvage_long-feedback"
                    ></b-form-input>
                    <template #append>
                      <b-input-group-text>cm</b-input-group-text>
                    </template>
                  </b-input-group>
                  <b-form-invalid-feedback
                    id="input-shrinking_selvage_long-feedback"
                    >Este campo es obligatorio.</b-form-invalid-feedback
                  >
                </b-form-group></b-col
              >
              <b-col :cols="6"></b-col>

              <b-col :cols="2">por lavado</b-col>
              <b-col :cols="2"
                ><b-form-group
                  id="input-shrinking_wash_width"
                  class="col-8 pl-0"
                  label-for="shrinking_wash_width"
                >
                  <b-input-group>
                    <b-form-input
                      id="shrinking_wash_width"
                      :value="
                        $v.form.shrinking_wash_width.$model.replace('.', ',')
                      "
                      @change="setDecimal('shrinking_wash_width', $event)"
                      :state="validateState('shrinking_wash_width')"
                      aria-describedby="input-shrinking_wash_width-feedback"
                    ></b-form-input>
                    <template #append>
                      <b-input-group-text>cm</b-input-group-text>
                    </template>
                  </b-input-group>
                  <b-form-invalid-feedback
                    id="input-shrinking_wash_width-feedback"
                    >Este campo es obligatorio.</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col :cols="2"
                ><b-form-group
                  id="input-shrinking_wash_long"
                  class="col-8 pl-0"
                  label-for="shrinking_wash_long"
                >
                  <b-input-group>
                    <b-form-input
                      id="shrinking_wash_long"
                      :value="
                        $v.form.shrinking_wash_long.$model.replace('.', ',')
                      "
                      @change="setDecimal('shrinking_wash_long', $event)"
                      :state="validateState('shrinking_wash_long')"
                      aria-describedby="input-shrinking_wash_long-feedback"
                    ></b-form-input>
                    <template #append>
                      <b-input-group-text>cm</b-input-group-text>
                    </template>
                  </b-input-group>
                  <b-form-invalid-feedback
                    id="input-shrinking_wash_long-feedback"
                    >Este campo es obligatorio.</b-form-invalid-feedback
                  >
                </b-form-group></b-col
              >
              <b-col :cols="6"></b-col>
            </b-form-row>

            <h5>Rapport</h5>

            <b-form-row class="mt-3">
              <b-form-group
                id="input-rapport_width"
                class="col-2"
                label="Ancho"
                label-for="rapport_width"
              >
                <b-input-group>
                  <b-form-input
                    id="rapport_width"
                    :value="$v.form.rapport_width.$model.replace('.', ',')"
                    @change="setDecimal('rapport_width', $event)"
                    :state="validateState('rapport_width')"
                    aria-describedby="input-rapport_width-feedback"
                  ></b-form-input>
                  <template #append>
                    <b-input-group-text>cm</b-input-group-text>
                  </template>
                </b-input-group>
                <b-form-invalid-feedback id="input-rapport_width-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
              <b-form-group
                id="input-rapport_long"
                class="col-2"
                label="Largo"
                label-for="rapport_long"
              >
                <b-input-group>
                  <b-form-input
                    id="rapport_long"
                    :value="$v.form.rapport_long.$model.replace('.', ',')"
                    @change="setDecimal('rapport_long', $event)"
                    :state="validateState('rapport_long')"
                    aria-describedby="input-rapport_long-feedback"
                  ></b-form-input>
                  <template #append>
                    <b-input-group-text>cm</b-input-group-text>
                  </template>
                </b-input-group>
                <b-form-invalid-feedback id="input-rapport_long-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row>

            <h4 class="mt-3">Precios</h4>

            <b-form-row>
              <b-form-group
                id="input-cost_meter"
                class="col-3"
                label="Coste (por metro)"
                label-for="cost_meter"
                description="IA_COSTE_METRO_TELA (IA_COSTE_CM_TELA)"
              >
                <b-input-group>
                  <b-form-input
                    id="cost_meter"
                    :value="$v.form.cost_meter.$model.replace('.', ',')"
                    @change="
                      setDecimal('cost_meter', $event);
                      calcIncreaseProcessed();
                    "
                    :state="validateState('cost_meter')"
                    aria-describedby="input-cost_meter-feedback"
                  ></b-form-input>
                  <template #append>
                    <b-input-group-text>€</b-input-group-text>
                  </template>
                </b-input-group>

                <b-form-invalid-feedback id="input-cost_meter-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                id="input-cost_roll"
                class="col-3"
                label="Coste (por rollo)"
                label-for="cost_roll"
              >
                <b-input-group>
                  <b-form-input
                    id="cost_roll"
                    :value="$v.form.cost_roll.$model.replace('.', ',')"
                    @change="
                      setDecimal('cost_roll', $event);
                      calcIncreaseProcessed();
                    "
                    :state="validateState('cost_roll')"
                    aria-describedby="input-cost_roll-feedback"
                  ></b-form-input>
                  <template #append>
                    <b-input-group-text>€</b-input-group-text>
                  </template>
                </b-input-group>

                <b-form-invalid-feedback id="input-cost_roll-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row>

            <b-form-row class="mt-2 pb-2">
              <b-col cols="2"></b-col>
              <b-col cols="2">Incremento sobre coste</b-col>
              <b-col cols="2">Euros/metro</b-col>
              <b-col cols="2">Euros/rollo</b-col>
              <b-col cols="2">PVP Euros/metro</b-col>
              <b-col cols="2"></b-col>
            </b-form-row>
            <b-form-row>
              <b-col cols="2">Producto procesado</b-col>

              <b-col cols="2"
                ><b-form-group
                  id="input-price_processed_increase"
                  class="col-8 pl-0"
                  label-for="price_processed_increase"
                >
                  <b-input-group>
                    <b-form-input
                      id="price_processed_increase"
                      :value="
                        $v.form.price_processed_increase.$model.replace(
                          '.',
                          ','
                        )
                      "
                      @change="
                        setDecimal('price_processed_increase', $event);
                        calcIncreaseProcessed();
                      "
                      :state="validateState('price_processed_increase')"
                      aria-describedby="input-price_processed_increase-feedback"
                    ></b-form-input>
                    <template #append>
                      <b-input-group-text>%</b-input-group-text>
                    </template>
                  </b-input-group>

                  <b-form-invalid-feedback
                    id="input-price_processed_increase-feedback"
                    >Este campo es obligatorio.</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col cols="2"
                ><b-form-group
                  id="input-price_processed_meter"
                  class="col-8 pl-0"
                  label-for="price_processed_meter"
                  description="IA_PRECIO_METRO_TELA (IA_PRECIO_CM_TELA)"
                >
                  <b-input-group>
                    <b-form-input
                      id="price_processed_meter"
                      :value="
                        $v.form.price_processed_meter.$model.replace('.', ',')
                      "
                      :disabled="true"
                      aria-describedby="input-price_processed_meter-feedback"
                    ></b-form-input>
                    <template #append>
                      <b-input-group-text>€</b-input-group-text>
                    </template>
                  </b-input-group>

                  <b-form-invalid-feedback
                    id="input-price_processed_meter-feedback"
                    >Este campo es obligatorio.</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col cols="2"
                ><b-form-group
                  id="input-price_processed_roll"
                  class="col-8 pl-0"
                  label-for="price_processed_roll"
                >
                  <b-input-group>
                    <b-form-input
                      id="price_processed_roll"
                      :disabled="true"
                      :value="
                        $v.form.price_processed_roll.$model.replace('.', ',')
                      "
                      aria-describedby="input-price_processed_roll-feedback"
                    ></b-form-input>
                    <template #append>
                      <b-input-group-text>€</b-input-group-text>
                    </template>
                  </b-input-group>

                  <b-form-invalid-feedback
                    id="input-price_processed_roll-feedback"
                    >Este campo es obligatorio.</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col cols="4"></b-col>
            </b-form-row>
            <b-form-row>
              <b-col cols="2">Tela por metro</b-col>

              <b-col cols="2"
                ><b-form-group
                  id="input-price_per_meter_increase"
                  class="col-8 pl-0"
                  label-for="price_per_meter_increase"
                >
                  <b-input-group>
                    <b-form-input
                      id="price_per_meter_increase"
                      :value="
                        $v.form.price_per_meter_increase.$model.replace(
                          '.',
                          ','
                        )
                      "
                      @change="
                        setDecimal('price_per_meter_increase', $event);
                        calcIncreaseProcessed();
                      "
                      :state="validateState('price_per_meter_increase')"
                      aria-describedby="input-price_per_meter_increase-feedback"
                    ></b-form-input>
                    <template #append>
                      <b-input-group-text>%</b-input-group-text>
                    </template>
                  </b-input-group>

                  <b-form-invalid-feedback
                    id="input-price_per_meter_increase-feedback"
                    >Este campo es obligatorio.</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col cols="2"
                ><b-form-group
                  id="input-price_per_meter_meter"
                  class="col-8 pl-0"
                  label-for="price_per_meter_meter"
                  description="IA_PRECIO_METRO_TELA_TM"
                >
                  <b-input-group>
                    <b-form-input
                      id="price_per_meter_meter"
                      :value="
                        $v.form.price_per_meter_meter.$model.replace('.', ',')
                      "
                      :disabled="true"
                      aria-describedby="input-price_per_meter_meter-feedback"
                    ></b-form-input>
                    <template #append>
                      <b-input-group-text>€</b-input-group-text>
                    </template>
                  </b-input-group>

                  <b-form-invalid-feedback
                    id="input-price_per_meter_meter-feedback"
                    >Este campo es obligatorio.</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col cols="2"
                ><b-form-group
                  id="input-price_per_meter_roll"
                  class="col-8 pl-0"
                  label-for="price_per_meter_roll"
                >
                  <b-input-group>
                    <b-form-input
                      id="price_per_meter_roll"
                      :value="
                        $v.form.price_per_meter_roll.$model.replace('.', ',')
                      "
                      :disabled="true"
                      aria-describedby="input-price_per_meter_roll-feedback"
                    ></b-form-input>
                    <template #append>
                      <b-input-group-text>€</b-input-group-text>
                    </template>
                  </b-input-group>

                  <b-form-invalid-feedback
                    id="input-price_per_meter_roll-feedback"
                    >Este campo es obligatorio.</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col cols="2"
                ><b-form-group
                  id="input-price_per_meter_retail_final"
                  class="col-8 pl-0"
                  label-for="price_per_meter_retail_final"
                >
                  <b-input-group>
                    <b-form-input
                      id="price_per_meter_retail_final"
                      :value="
                        $v.form.price_per_meter_retail_final.$model.replace(
                          '.',
                          ','
                        )
                      "
                      :disabled="true"
                      aria-describedby="input-price_per_meter_retail_final-feedback"
                    ></b-form-input>
                    <template #append>
                      <b-input-group-text>€</b-input-group-text>
                    </template>
                  </b-input-group>

                  <b-form-invalid-feedback
                    id="input-price_per_meter_retail_final-feedback"
                    >Este campo es obligatorio.</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col cols="2"></b-col>
            </b-form-row>

            <b-button type="submit" variant="primary">Guardar tela</b-button>
          </b-form>
          <!-- /Form -->
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { required, decimal, minValue } from 'vuelidate/lib/validators';

import { actions } from '@/admin/api.js';

import store from '@/admin/store.js';
import { validationMixin } from 'vuelidate';

import { helpers } from 'vuelidate/lib/validators';

import * as Sentry from '@sentry/browser';

import Multiselect from 'vue-multiselect';

import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

const isValidImage = (image) =>
  !helpers.req(image) || ['image/jpeg', 'image/png'].includes(image['type']);

export default {
  name: 'AdminColorsEditScreen',
  props: ['id'],
  components: { Multiselect, VueCropper },
  mixins: [validationMixin],
  validations() {
    let rules = {
      reference: {
        required,
      },
      image: {
        isValidImage,
      },
      icon: {
        isValidImage,
      },
      provider: { required },
      ref_provider: {
        required,
      },
      base_width: {},
      base_length: {},
      width: {},
      composition: { required },
      weight: {},
      primary_color_code_hex: {},
      extra_type: {},

      color_families: {},
      design: {},
      cost_meter: {
        required,
        decimal,
        minValue: minValue(0.0),
      },
      cost_roll: {
        required,
        decimal,
        minValue: minValue(0.0),
      },
      shrinking_selvage_width: {},
      shrinking_selvage_long: {},
      shrinking_wash_width: {},
      shrinking_wash_long: {},
      rapport_width: {},
      rapport_long: {},
      transparency: {},
      show_our_fabrics: {},
      is_discontinued: {},
      price_processed_increase: {},
      price_processed_meter: {},
      price_processed_roll: {},
      price_per_meter_increase: {},
      price_per_meter_meter: {},
      price_per_meter_roll: {},
      price_per_meter_retail_final: {},
      icon_coords_x: {},
      icon_coords_y: {},
      icon_coords_w: {},
      num_barcada: {},
      meters_barcada_remaining: {},
    };

    // this.languageCodes.map((x) => {
    //   rules['name_' + x] = { required };
    // });

    return {
      form: rules,
    };
  },
  data() {
    let form = {
      image: null,
      icon: null,
      imageURI: null,
      iconURI: null,
      reference: '',
      provider: '',
      ref_provider: '',
      base_width: '',
      base_length: '',
      width: '',
      composition: [],
      weight: '',
      primary_color_code_hex: '',
      extra_type: '',
      color_families: [],
      design: [],
      cost_meter: '',
      cost_roll: '',
      shrinking_selvage_width: '',
      shrinking_selvage_long: '',
      shrinking_wash_width: '',
      shrinking_wash_long: '',
      rapport_width: '',
      rapport_long: '',
      num_barcada: '',
      meters_barcada_remaining: '0',
      transparency: '',
      show_our_fabrics: '',
      is_discontinued: '',
      price_processed_increase: '',
      price_processed_meter: '',
      price_processed_roll: '',
      price_per_meter_increase: '',
      price_per_meter_meter: '',
      price_per_meter_roll: '',
      price_per_meter_retail_final: '',
      icon_coords_x: 0,
      icon_coords_y: 0,
      icon_coords_w: 300,
      error: {
        show: false,
        text: '',
      },
      optionsCompositions: [],
      optionsColorFamilies: [],
      optionsDesigns: [],
    };

    // store.getLanguageCodes().map((x) => {
    //   form['name_' + x] = '';
    // });

    return {
      sharedState: store.state,
      languageCodes: store.getLanguageCodes().filter((x) => x == 'es'),
      languageNames: store.getLanguageNames(),
      hover: false,
      form: form,
    };
  },
  created() {
    let preloadPromises = [];

    preloadPromises.push(
      actions.getFabricCompositions(),
      actions.getFabricColorFamilies(),
      actions.getFabricDesigns()
    );

    Promise.all(preloadPromises).then((z) => {
      this.form.optionsCompositions = z[0].data.results.map((y) => {
        return {
          value: y.id,
          text: y.name,
        };
      });

      this.form.optionsColorFamilies = z[1].data.results.map((y) => {
        return {
          value: y.id,
          text: y.name,
        };
      });

      this.form.optionsDesigns = z[2].data.results.map((y) => {
        return {
          value: y.id,
          text: y.name,
        };
      });

      if (this.id !== 'new') {
        actions.getFabric(this.id).then((x) => {
          const data = x.data;

          this.form.reference = data.reference;

          this.form.imageURI = data.image;
          this.form.iconURI = data.icon;

          this.form.provider = data.provider;
          this.form.ref_provider = data.ref_provider;

          this.form.base_width = data.base_width ? data.base_width : '';
          this.form.base_length = data.base_length ? data.base_length : '';

          this.form.width = data.width ? data.width : '';
          this.form.composition = this.form.optionsCompositions.find((y) =>
            data.composition.includes(y.value)
          );
          this.form.weight = data.weight ? data.weight : '';

          this.form.primary_color_code_hex = data.primary_color_code_hex
            ? data.primary_color_code_hex
            : '';

          this.form.extra_type = data.extra_type ? data.extra_type : '';

          this.form.color_families = this.form.optionsColorFamilies.filter(
            (y) => data.color_families.includes(y.value)
          );
          this.form.design = this.form.optionsDesigns.filter((y) =>
            data.design.includes(y.value)
          );
          this.form.cost_meter = data.cost_meter;
          this.form.cost_roll = data.cost_roll;
          this.form.shrinking_selvage_width = data.shrinking_selvage_width
            ? data.shrinking_selvage_width
            : '';
          this.form.shrinking_selvage_long = data.shrinking_selvage_long
            ? data.shrinking_selvage_long
            : '';
          this.form.shrinking_wash_width = data.shrinking_wash_width
            ? data.shrinking_wash_width
            : '';
          this.form.shrinking_wash_long = data.shrinking_wash_long
            ? data.shrinking_wash_long
            : '';
          this.form.rapport_width = data.rapport_width
            ? data.rapport_width
            : '';

          this.form.num_barcada = data.num_barcada;
          this.form.meters_barcada_remaining = data.meters_barcada_remaining;

          this.form.rapport_long = data.rapport_long ? data.rapport_long : '';
          this.form.transparency = data.transparency;
          this.form.show_our_fabrics = data.show_our_fabrics;
          this.form.is_discontinued = data.is_discontinued;
          this.form.price_processed_increase = data.price_processed_increase;
          this.form.price_processed_meter = data.price_processed_meter;
          this.form.price_processed_roll = data.price_processed_roll;
          this.form.price_per_meter_increase = data.price_per_meter_increase;
          this.form.price_per_meter_meter = data.price_per_meter_meter;
          this.form.price_per_meter_roll = data.price_per_meter_roll;
          this.form.price_per_meter_retail_final =
            data.price_per_meter_retail_final;

          this.form.icon_coords_y = data.icon_coords_y;
          this.form.icon_coords_x = data.icon_coords_x;
          this.form.icon_coords_w = data.icon_coords_w;

          // this.languageCodes.map((y) => {
          //   this.form['name_' + y] = data['name_' + y];
          // });
        });
      }
    });
  },
  methods: {
    cropIconModalShown() {
      let lastValidCrop = this.$refs.cropper.getData();

      lastValidCrop['x'] = this.form.icon_coords_x;
      lastValidCrop['y'] = this.form.icon_coords_y;
      lastValidCrop['width'] = this.form.icon_coords_w;

      this.$refs.cropper.setData(lastValidCrop);
    },
    mouseOver() {
      this.hover = true;
    },
    mouseOut() {
      this.hover = false;
    },
    getDataURIFromFile(file) {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.onload = () => resolve(fileReader.result);
        fileReader.readAsDataURL(file);
      });
    },
    changedImage(newFile) {
      this.getDataURIFromFile(newFile).then((result) => {
        this.form.imageURI = result;
      });
    },
    cropIcon() {
      let data = this.$refs.cropper.getData();

      this.form.icon_coords_x = data.x;
      this.form.icon_coords_y = data.y;
      this.form.icon_coords_w = data.width;

      this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
        // Pass the image file name as the third parameter if necessary.

        this.form.icon = blob;

        this.getDataURIFromFile(blob).then((result) => {
          this.form.iconURI = result;
        });
      });
    },
    setDecimal(name, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this.$v.form[name].$model = val;
      this.$v.form[name].$touch();
    },
    calcIncreaseProcessed() {
      if (
        parseFloat(this.$v.form['cost_meter'].$model) > 0 &&
        parseFloat(this.$v.form['price_processed_increase'].$model) > 0
      ) {
        this.$v.form['price_processed_meter'].$model = (
          parseFloat(this.$v.form['cost_meter'].$model) *
          (1 +
            parseFloat(this.$v.form['price_processed_increase'].$model) / 100.0)
        ).toFixed(2);
      }

      if (
        parseFloat(this.$v.form['cost_roll'].$model) > 0 &&
        parseFloat(this.$v.form['price_processed_increase'].$model) > 0
      ) {
        this.$v.form['price_processed_roll'].$model = (
          parseFloat(this.$v.form['cost_roll'].$model) *
          (1 +
            parseFloat(this.$v.form['price_processed_increase'].$model) / 100.0)
        ).toFixed(2);
      }

      if (
        parseFloat(this.$v.form['cost_meter'].$model) > 0 &&
        parseFloat(this.$v.form['price_per_meter_increase'].$model) > 0
      ) {
        this.$v.form['price_per_meter_meter'].$model = (
          parseFloat(this.$v.form['cost_meter'].$model) *
          (1 +
            parseFloat(this.$v.form['price_per_meter_increase'].$model) / 100.0)
        ).toFixed(2);
      }

      if (
        parseFloat(this.$v.form['cost_roll'].$model) > 0 &&
        parseFloat(this.$v.form['price_per_meter_increase'].$model) > 0
      ) {
        this.$v.form['price_per_meter_roll'].$model = (
          parseFloat(this.$v.form['cost_roll'].$model) *
          (1 +
            parseFloat(this.$v.form['price_per_meter_increase'].$model) / 100.0)
        ).toFixed(2);

        if (parseFloat(this.$v.form['price_per_meter_meter'].$model) > 0) {
          this.$v.form['price_per_meter_retail_final'].$model = (
            parseFloat(this.$v.form['price_per_meter_meter'].$model) * 1.21
          ).toFixed(2);
        }
      }
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      store.setOverlayShow(true);

      let data = new FormData();

      if (this.form.image !== null) {
        data.append('image', this.form.image);
      } else if (this.form.imageURI === null) {
        data.append('image', new File([], ''));
      }

      if (this.form.icon !== null) {
        data.append(
          'icon',
          this.form.icon,
          'icon-' +
            (this.form.image !== null
              ? this.form.image.name
              : this.form.imageURI.split('/').pop())
        );
      } else if (this.form.iconURI === null) {
        data.append('icon', new File([], ''));
      }

      data.append('reference', this.form.reference);
      data.append('provider', this.form.provider);

      data.append('base_width', this.form.base_width);
      data.append('base_length', this.form.base_length);

      data.append('ref_provider', this.form.ref_provider);
      data.append('width', this.form.width);
      data.append('composition', JSON.stringify([this.form.composition.value]));
      data.append('weight', this.form.weight);
      data.append('primary_color_code_hex', this.form.primary_color_code_hex);
      data.append('extra_type', this.form.extra_type);

      data.append(
        'color_families',
        JSON.stringify(this.form.color_families.map((x) => x.value))
      );
      data.append(
        'design',
        JSON.stringify(this.form.design.map((x) => x.value))
      );
      data.append('cost_meter', this.form.cost_meter);
      data.append('cost_roll', this.form.cost_roll);
      data.append('rapport_width', this.form.rapport_width);
      data.append('rapport_long', this.form.rapport_long);

      data.append('num_barcada', this.form.num_barcada);
      data.append(
        'meters_barcada_remaining',
        this.form.meters_barcada_remaining
      );
      data.append(
        'price_processed_increase',
        this.form.price_processed_increase
      );
      data.append('price_processed_meter', this.form.price_processed_meter);
      data.append('price_processed_roll', this.form.price_processed_roll);
      data.append(
        'price_per_meter_increase',
        this.form.price_per_meter_increase
      );
      data.append('price_per_meter_meter', this.form.price_per_meter_meter);
      data.append('price_per_meter_roll', this.form.price_per_meter_roll);
      data.append(
        'price_per_meter_retail_final',
        this.form.price_per_meter_retail_final
      );
      data.append('shrinking_selvage_width', this.form.shrinking_selvage_width);
      data.append('shrinking_selvage_long', this.form.shrinking_selvage_long);
      data.append('shrinking_wash_width', this.form.shrinking_wash_width);
      data.append('shrinking_wash_long', this.form.shrinking_wash_long);
      data.append('transparency', this.form.transparency);
      data.append('show_our_fabrics', this.form.show_our_fabrics);
      data.append('is_discontinued', this.form.is_discontinued);

      data.append('icon_coords_x', parseInt(this.form.icon_coords_x));
      data.append('icon_coords_y', parseInt(this.form.icon_coords_y));
      data.append('icon_coords_w', parseInt(this.form.icon_coords_w));

      // this.languageCodes.map((x) => {
      //   data.append('name_' + x, this.form['name_' + x]);
      // });

      // data.append('name', this.form['name_' + this.languageCodes[0]]);

      Sentry.setExtra('data', JSON.stringify(Object.fromEntries(data)));

      if (this.id !== 'new') {
        actions.patchFabric(this.id, data).then(() => {
          this.$router.push({ name: 'AdminFabricsScreen' });
        });
      } else {
        actions.postFabric(data).then((x) => {
          this.$router.push({ name: 'AdminFabricsScreen' });
        });
      }
    },
  },
  mounted() {},
};
</script>

<style scoped></style>
